/**
 * IFC model profile cache.
 */
export class AP214ModelProfile {
    constructor() {
        this.profiles_ = new Map();
    }
    /**
     * Get the number of profiles in this.
     *
     * @return {number}
     */
    get length() {
        return this.profiles_.size;
    }
    /**
     * Add a profile to the cache.
     *
     * @param profile
     */
    add(profile) {
        this.profiles_.set(profile.localID, profile);
    }
    /**
     * Get a profile by its local id.
     *
     * @param localID
     * @return {CanonicalProfile | undefined}
     */
    getByLocalID(localID) {
        return this.profiles_.get(localID);
    }
    /**
     * Iterate through the profiles in this.
     *
     * @return {IterableIterator<CanonicalProfile>}
     */
    [Symbol.iterator]() {
        return this.profiles_.values();
    }
}
